import {getTeamStatusRating, getTeamHpRating} from '../../analysis/team-analysis-utilities.js'

//Look at the ID of the super and evaluate if it should be used
export function isSuperValid(superId, teamCombatants, enemyCombatants, casterModel) {

  //Case 1: return TRUE if there are 2 or more alive enemies.
  if (
    superId === "special_team-foreach" ||
    superId === "special_team-slice" ||
    superId === "special_wildfire"
  ) {
    const aliveEnemyCombatantCount = enemyCombatants.filter(combModel => combModel.isAlive()).length;
    return (aliveEnemyCombatantCount >= 2)
  }

  //Case 2: TEAM CLEAN: return TRUE if friendlies have bad statuses
  if (superId === "special_team-clean") {
    const teamStatusRating = getTeamStatusRating(teamCombatants);
    return teamStatusRating < 50; //less than normal avg
  }

  //Case 3: TEAM REVIVE: return TRUE if 1 or more friendlies are dead
  if (superId === "special_team-revive") {
    const deadFriendlyCombatantCount = teamCombatants.filter(combModel => !combModel.isAlive()).length;
    return (deadFriendlyCombatantCount >= 1)
  }

  //Case 4: COMMIT: return true if the friendly team HP and statuses look good.
  if (superId === "special_commit") {
    if ( getTeamStatusRating(teamCombatants) >= 50 && getTeamHpRating(teamCombatants) >= 75) {

      if (!casterModel.committedTurnData) { //Don't use this if Bot already has a Commit. Trust that the old one is good.
        return true
      }
    }
  }
  //Case 4b: REVERT: return true if friendly HP and statuses don't look good
  if (superId === "special_revert") {
    if ( getTeamStatusRating(teamCombatants) === 0 || getTeamHpRating(teamCombatants) < 50) {
      return true
    }
  }

  //Case 5: SQL DROP! Delete all enemy items
  if (superId === "special_sql-drop") {
    const sampleEnemy = enemyCombatants[0];
    if (sampleEnemy.getTeamItems().length > 0) {
      return true
    }
  }

  return false;
}


// WEBPACK FOOTER //
// ./src/battle/bot-decisions/super-paths/validate-supers.js